export default "__VITE_ASSET__220bbc15__"